export function toError(x) {
    return x instanceof Error ? x : Error(`${x}`);
}
export function getErrorMessage(x) {
    return x instanceof Error ? x.message : `${x}`;
}
export function augmentErrorMessage(e, message) {
    if (e instanceof Error) {
        e.message = `${message} (${e.message})`;
    }
    return e;
}
export const abortErrorName = "AbortError";
export function isAbortError(e) {
    return e instanceof DOMException && e.name === abortErrorName;
}
export function throwAbortError() {
    throw new DOMException("", abortErrorName);
}
export function throwOnAbort(abortSignal) {
    if (abortSignal.aborted) {
        throwAbortError();
    }
}
